
import { getCookie, getQueryParameterByName, setCookie } from "../../utils"

export default {
    data() {
        return {
            urls: ['yandex', 'google', 'ya.ru', 'bing', 'mail.ru', 'yahoo', 'duckduckgo', 'rambler'],
            urlTesting: false,
            firstvVisitTesting: false
        }
    },
    methods: {
        initChangePhones() {
            /* Меняем телефон если страница находится в разделе /deposits/ или это промо higher-rate, и в get параметре нет utm, и пользователь пришёл с определенной страницы.
            Также проверяем по значению в sessionStorage на случай, если пользователь начинает ходить по страницам сайта */

            if (
                location.search === ''
                && this.urlTesting
                && this.firstVisitTesting
                &&(location.pathname.indexOf('/deposits/') !== -1 || location.pathname.indexOf('/promo/higher-rate') !== -1)
            ) {
                let phones = document.querySelectorAll('a[href="tel:+78007758686"]');
                phones.forEach(phone => {
                    if (phone.innerHTML !== '' && phone.innerHTML !== 'Позвонить в банк') {
                        phone.innerHTML = '8 495 877-48-99';
                    }
                    phone.setAttribute('href', 'tel:+74958774899')
                })
            }
        },
        urlCheckout() {
            const checkout = this.urls.filter(val => document.referrer.indexOf(val) !== -1);
            return checkout.length ? true : false;
        },
        firstVisitCheckout() {
            if (!localStorage.getItem('deposits_searching_first_visiting')) {
                localStorage.setItem('deposits_searching_first_visiting', true);
                return true;
            }
            else {
                return false;
            }
        },
        initDepositsUtm() {
            if (getQueryParameterByName('utm_campaign')?.startsWith('per_') && getQueryParameterByName('utm_source') && (location.pathname.indexOf('/deposits/') !== -1 || location.pathname.indexOf('/promo/higher-rate/') !== -1 || location.pathname.indexOf('/promo/higher-rate-promocode') !== -1) && location.pathname.indexOf('/promo/deposits/') !== 0) {
                sessionStorage.setItem('deposit_source', location.search);
            }
        },
        // проверяет последнюю группу параметров в строке параметров url-param в cookies
        // нужно для того чтобы при обновлении страницы не дублировались группы параметров друг за другом
        lastParamsIsSame() {
            let arrParams = getCookie('url-param').split(',');
            return arrParams[arrParams.length-1] === location.search
        },
        // записываем в url-param параметры из адресной строки. если запись уже есть, то добавляем следующую группу параметров в конец, разделяя запятой
        setUrlParamToSessionStorage() {
            if (!location.search || getQueryParameterByName('utm_source') || getQueryParameterByName('utm_campaign')) return;

            if (getCookie('url-param')) {
                if (this.lastParamsIsSame()) return;
                setCookie('url-param', getCookie('url-param') + ',' + location.search, {path: '/'});
            } else {
                setCookie('url-param', location.search, {path: '/'});
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.urlTesting = this.urlCheckout();
            if (this.urlTesting) this.firstVisitTesting = this.firstVisitCheckout()

            if (getQueryParameterByName('utm_source') && !sessionStorage.getItem('source')) {
                sessionStorage.setItem('source', location.search);
            }
            if (getQueryParameterByName('utm_campaign') && !sessionStorage.getItem('utm_campaign')) {
                sessionStorage.setItem('utm_campaign', location.search);
            }

            if (getCookie('_ym_uid')) {
                setCookie('DOMRF_GLOBAL_YCLID', getCookie('_ym_uid'), {path: '/'});
            }

            this.setUrlParamToSessionStorage()
            this.initChangePhones();
            this.initDepositsUtm();
        }, 2000)
    }
}
